export type DataOption = {
    value: string | number | string[],
    text: string,
    isSelected?: boolean
}

export class InputDropdownReplacementProperties {
    data!: DropdownDataOption[];
    inputSelector: any;
    dropdownId!: string;
    isMultiSelect?: boolean;
    enableOtherOption?: boolean;

    constructor() {
        this.isMultiSelect = false;
        this.enableOtherOption = false;
    }
}

export class DropdownOptionInputsReplacementProperties {
    dropdownSelector: any;
    optionsContainerId: string;
    optionsNameId: string;
    numberOfColumns?: number;
    optionsIgnoreList?: any[];

    constructor() {
        this.dropdownSelector = null;
        this.optionsContainerId = "";
        this.optionsNameId = "";
        this.numberOfColumns = 4;
        this.optionsIgnoreList = [];
    }
}

export type DropdownDataOption = {
    value: string | number,
    description: string
}